module.exports = __webpack_public_path__ + "img/top.a0f88887.jpg";